import React from 'react';
import Box from '@mui/material/Box';

import { SimTypography } from 'components/SimTypography';
import SimFeaturedServiceSlider from 'components/SimFeaturedServiceSlider';

const SliderALLEssentialsServices = () => {
	return (
		<Box>
			<Box marginBottom={4}>
				<SimTypography
					sx={{
						textTransform: 'uppercase',
						fontWeight: 'medium'
					}}
					gutterBottom
					color={'secondary'}
					align={'center'}>
					Featured Services
				</SimTypography>

				<SimTypography
					variant='h3'
					align={'center'}
					data-aos={'fade-up'}
					gutterBottom
					sx={{
						fontWeight: 700
					}}>
					Browse our service catalogue
				</SimTypography>
				<SimTypography variant='h6' align={'center'} data-aos={'fade-up'}>
					Here are our top services driven by experts
				</SimTypography>
				<Box
					display='flex'
					flexDirection={{ xs: 'column', sm: 'row' }}
					alignItems={{ xs: 'stretched', sm: 'flex-start' }}
					justifyContent={'center'}
					marginTop={2}></Box>
			</Box>

			<SimFeaturedServiceSlider />
		</Box>
	);
};

export { SliderALLEssentialsServices };
